import { createSelector, MemoizedSelector } from '@ngrx/store';

import * as fromFeature from './../reducers';
import * as fromUserInformation from '../reducers/user-information.reducer';
import { User } from '../../../user-management/users/user';

export const getUserInformationSlice: MemoizedSelector<
  object,
  any
> = createSelector(
  fromFeature.getAccountState,
  (state: fromFeature.AccountState) => state.userInformation
);

export const getUserInformation: MemoizedSelector<
  object,
  User
> = createSelector(
  getUserInformationSlice,
  fromUserInformation.getUserInformationEntity
);

export const getUserInformationLoaded: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getUserInformationSlice,
  fromUserInformation.getUserInformationLoaded
);

export const getUserInformationLoading: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getUserInformationSlice,
  fromUserInformation.getUserInformationLoading
);
